
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as indexQ_45p_R8nWqy4cZICdOG47zZGdB894pqt8jkBF_45IT0qhIMeta } from "/app/pages/home/index.vue?macro=true";
import { default as index06RuUPKkpIkYJ1u5ZQ6kHhkE76Z6rwcTsSwg0fLJR9IMeta } from "/app/pages/login/index.vue?macro=true";
import { default as newWc_F9IF7ScYj8JRK2BJERfFQIISxrzktOXmpI0DlbpAMeta } from "/app/pages/rewards/new.vue?macro=true";
import { default as send_k0b_45AjsM0cTyp5mMJ_BbKW1LQAyZj2XdxI_Ge9H9rEMeta } from "/app/pages/seeding/send.vue?macro=true";
import { default as indexcpQviwpni6wMDdVA_BzQ_45kBCtc89Z5fb_458HFdQRVAm8Meta } from "/app/pages/sign-up/index.vue?macro=true";
import { default as index_co3iOp8B9M5qx3rHu_45X0i7TlvmPQyobRFNEElS73OcMeta } from "/app/pages/branding/index.vue?macro=true";
import { default as indexfodtTBtuLo_45yQsALKT8_4522bgRi9W4SQ_MW16Qo5TXckMeta } from "/app/pages/referral/index.vue?macro=true";
import { default as productYY3eUPbIONly1KIDLSQT6eKmXC6hZo_INFaqh9EyxWkMeta } from "/app/pages/seeding/product.vue?macro=true";
import { default as upgrademh_45hnbAfnM60_45jiiE8As5CYTVN6e79WI1syU_45XCTGVkMeta } from "/app/pages/seeding/upgrade.vue?macro=true";
import { default as install6mZYl4gcYrWiJhwnR0AnNtP3A_ztzBMMu49KG_MVPvYMeta } from "/app/pages/shopify/install.vue?macro=true";
import { default as indexdrrcxBLgKkbQGcJP_0EWHslYcJSUtUUVRdOVJw3L7_wMeta } from "/app/pages/vip-tiers/index.vue?macro=true";
import { default as upgrade9GvkqavSyByM6RRWq3u7G6L6WLHHCmm_wAu6wTyKdgsMeta } from "/app/pages/referral/upgrade.vue?macro=true";
import { default as templateD5OeSL_45sKCLAVW5Tf2fzCllhWbfnK_b8jwl4_45ShRzhgMeta } from "/app/pages/rewards/template.vue?macro=true";
import { default as campaignstCfNk2hnXxDI3b0K8EeWtNPuGYV71sTAPjM_45z8dH1uwMeta } from "/app/pages/seeding/campaigns.vue?macro=true";
import { default as upgradeD9xwZ_45RJA85GHaIVdvArdfhnVInFIHeJEwyLRMgyoT8Meta } from "/app/pages/vip-tiers/upgrade.vue?macro=true";
import { default as installT19cDaxwefBLD_1MTP0eQZ6BDg7B6TOBbvBJuBi5T_45AMeta } from "/app/pages/prestashop/install.vue?macro=true";
import { default as indexJpATDRW0GsZkb3b3Ur2EexyX9qTGUX42SA5_45XZts1AMMeta } from "/app/pages/rewards/[id]/index.vue?macro=true";
import { default as indexpxwYt6birg4MZhQQf3tPpVYjL5QJcHRqlOuNkRwi84EMeta } from "/app/pages/rewards/list/index.vue?macro=true";
import { default as indexAVrTFjKauXzLEpvLVNhz_1DXD7rtw1qF1kXzyK2WrocMeta } from "/app/pages/rewards/send/index.vue?macro=true";
import { default as index6vWdshgMcWZlynt0_NWkkRc0tazoZU3VawCbwuBoyqQMeta } from "/app/pages/seeding/[id]/index.vue?macro=true";
import { default as index3QEx2FupW0AHCWvpxVVvjKuXWAsm6QUihF_Yjwl3UbYMeta } from "/app/pages/branding/page/index.vue?macro=true";
import { default as indexVQ_453amrRfo5jb_45mTQD0BgssIFcK7COyh7oObMvIkiqEMeta } from "/app/pages/branding/steps/index.vue?macro=true";
import { default as indexCgWkt59pzwVVHr4q1qrrnsVjZHSE2M81ROGrLb_bVaMMeta } from "/app/pages/company/create/index.vue?macro=true";
import { default as password_45resetD2BriM0bsre_45yKrFf0xOffJHJM0mcBZUC7VWBINvNxoMeta } from "/app/pages/login/password-reset.vue?macro=true";
import { default as previewBA_7QfRyiXhhNnRqicu5b5SFHr0jpvbfnf7xhWKGgEoMeta } from "/app/pages/seeding/[id]/preview.vue?macro=true";
import { default as applicationsweQ7d27k_45HFZhJ0AFh2nF2M1FJPLtENqBhMzZJc782IMeta } from "/app/pages/seeding/applications.vue?macro=true";
import { default as indexd44eJ6_45Q9BmvwX13caOoD9UpSnP_45vTDTmw_45pEnO95XcMeta } from "/app/pages/ambassadors/crm/index.vue?macro=true";
import { default as indexXcEmH4PZTQXHDHYmFIRejk3ZpAXG7gc2P_WYRRhb1EYMeta } from "/app/pages/branding/banner/index.vue?macro=true";
import { default as indexqLOBV5QtUP7Hl9rrDFTCxOk3gWHvpMSVh20elGW1FJcMeta } from "/app/pages/branding/profil/index.vue?macro=true";
import { default as password_45forgottjU1zsFG8aQAD5hVUXj2STSakaR_1E_45rLLhLCg8Hx_oMeta } from "/app/pages/login/password-forgot.vue?macro=true";
import { default as _91id_93wMll62X3EKy057yKLFg8baHeGD4XTERBgygVzD9nRLwMeta } from "/app/pages/referral/rewards/[id].vue?macro=true";
import { default as missionsBRvANH11AHBu09Uza9dyMWysP6LX4C0U3jGLwR1QRREMeta } from "/app/pages/seeding/[id]/missions.vue?macro=true";
import { default as indexzzRbHYobRshklfqqQS_RCUtH0rmjXVYZg_45OrBqf1ZP8Meta } from "/app/pages/vip-tiers/level/index.vue?macro=true";
import { default as index_TkLrTl21T2Zb_QJVHqRcaoz53K738TcP7BoYGbWavMMeta } from "/app/pages/branding/general/index.vue?macro=true";
import { default as indexj_45ai1gcaBu1ZBexpRsg3yKoYyEqSWVeh_45JNd1AzseaIMeta } from "/app/pages/branding/gifting/index.vue?macro=true";
import { default as indexFM_45ysw42yV_gGaU3ILcxbJWTiXczLmR1hClGm6En_45BMMeta } from "/app/pages/branding/modules/index.vue?macro=true";
import { default as indexxlXOOnSLmm4ueaZS7B7uChuuFHdqh061VFSojCZrWHYMeta } from "/app/pages/branding/rewards/index.vue?macro=true";
import { default as indexAYnxRMyB2ewWYgYebdXQiscZ8R26_45Z4yV1Igvyqmx6gMeta } from "/app/pages/contents/library/index.vue?macro=true";
import { default as indexRHkQiexfp09NoNWXqDpKF5eGhQ4t423gwEJZYP_45wgHUMeta } from "/app/pages/branding/accounts/index.vue?macro=true";
import { default as indexezAfeBhJejKG7qs6kOp1uioJ8UI6RW_45bWtMDKxb_45DR8Meta } from "/app/pages/branding/missions/index.vue?macro=true";
import { default as index09IMUKHyrMNXzpS0Jkjze1JDCisDV378pPO8KyC5AokMeta } from "/app/pages/dashboard/loyalty/index.vue?macro=true";
import { default as indexvKH6g5D4HP5NfyQE2T7jmjRH7TXFg8GLaVHG4Skk1bYMeta } from "/app/pages/parameters/profil/index.vue?macro=true";
import { default as indexGmj_45eQHV1uYCaO3RXkFV032UWLjcSMGR4ltY0K90GZcMeta } from "/app/pages/programs/missions/index.vue?macro=true";
import { default as targetingsUo_1dbd2Xb2TPN5POfrEHZuHUmbng0ZgGaaZTkL9zZkMeta } from "/app/pages/seeding/[id]/targetings.vue?macro=true";
import { default as indexAKnUA00ieDO_45tTF7Hav3gxTsKmZviHXn69HINw1J3W0Meta } from "/app/pages/branding/referrals/index.vue?macro=true";
import { default as indexqsrcqPoS1N9JP7emjfuCw0DpjBiDYOlcCjoA8XWyHtsMeta } from "/app/pages/branding/vip-tiers/index.vue?macro=true";
import { default as indexLI00dfQCYGtD3TmC_v6mVAGaa5a_45XM7EN1d72R9InNcMeta } from "/app/pages/dashboard/missions/index.vue?macro=true";
import { default as indexJJ3aondRJkCU9OCuWWprulOVOiGs0DZOCSH41iXc_CgMeta } from "/app/pages/dashboard/referral/index.vue?macro=true";
import { default as indexkdzcV0fY2swAtoWQ3N9D01QbSqAJp_45NtBfvul32pUTQMeta } from "/app/pages/parameters/billing/index.vue?macro=true";
import { default as recruitmentZqyGoXRtTmx_45wl_HQdGn65Te9RiAo_45Sxy69IkwWdh1MMeta } from "/app/pages/seeding/[id]/recruitment.vue?macro=true";
import { default as finalYDbQoKbwvYnj_45rsvTdMIeRm89lBl2vrH1AODuO9riDwMeta } from "/app/pages/sign-up/onboarding/final.vue?macro=true";
import { default as goalsLfYOWh_45PfsCh3kjd5hs29VSnc7QeRkqB3n76FIOTdrQMeta } from "/app/pages/sign-up/onboarding/goals.vue?macro=true";
import { default as indexkh9esqB_D6soSPABtVKCrL9xpGox_45u93Jf5v0WJ8mcUMeta } from "/app/pages/contents/moderation/index.vue?macro=true";
import { default as indexwqZuM0lGVSQgPHXKG_453MR876e_458fcV2o1Vd6SrP6O2IMeta } from "/app/pages/dashboard/retention/index.vue?macro=true";
import { default as failedw3Ld7jVfJlz5IBuqqwXetbCVMJ0SvJz_GOKyBBqXn6oMeta } from "/app/pages/parameters/billing/failed.vue?macro=true";
import { default as indexRXRgniVlyyTE3rpjgyqg5_45nBggTxugSd9GhS4iO_0v0Meta } from "/app/pages/communication/emails/index.vue?macro=true";
import { default as successx_45jCFuMgmaQM7LiK9wAJXuNnBlRpu84eKAywJ_45YmhJUMeta } from "/app/pages/parameters/billing/success.vue?macro=true";
import { default as loyalty9YM89LydJVZ2xrWss35QF2yR5k9VKdEYL_xExsKcb2AMeta } from "/app/pages/sign-up/onboarding/loyalty.vue?macro=true";
import { default as rewardsSZlxJyqgDsLKSLL4natqHiLfzsUY3BaTbIsx5cLOoa8Meta } from "/app/pages/sign-up/onboarding/rewards.vue?macro=true";
import { default as socialsFrzvCG2LYwxGfM_45oVwYn_45cpOT1TlKSgTOmas4xyArW0Meta } from "/app/pages/sign-up/onboarding/socials.vue?macro=true";
import { default as websiteffZUSmSGrtxCaU3uXInQUtb0eUVfaBUNcSn2OkQWWq0Meta } from "/app/pages/sign-up/onboarding/website.vue?macro=true";
import { default as indexR9262P9JWb1gD9sUEg__fUPQHi2I_45D8ZsMk6lrGEvCEMeta } from "/app/pages/vip-tiers/level/[id]/index.vue?macro=true";
import { default as indexAT2AySntsIhLqPHRxNgLUwp0pB6n10uthD2Hdc7y1gYMeta } from "/app/pages/branding/translations/index.vue?macro=true";
import { default as index83wnLSxCrRwICzfXySQWOb7qiMFsj1YB6HhpSeePFioMeta } from "/app/pages/programs/loyalty/[id]/index.vue?macro=true";
import { default as indexIYWy1APJ8ADhiMc0cHWm__45PPjjDpa3q8WgOM4TVrcVcMeta } from "/app/pages/programs/missions/new/index.vue?macro=true";
import { default as preview_45detail_454RkTXReu9AUZ_451n9Sz4oIbhQKGvJDrM8tm8oF_45cq1AMeta } from "/app/pages/seeding/[id]/preview-detail.vue?macro=true";
import { default as brandingncKeAgicFLO4kXtGIW0M1LbtW8MRRVnWtdPnQgb1T5MMeta } from "/app/pages/sign-up/onboarding/branding.vue?macro=true";
import { default as referral6dEsTv6a0bnr7_45jky5LkmZjJBK3uNucd2xRLHieXQj8Meta } from "/app/pages/sign-up/onboarding/referral.vue?macro=true";
import { default as indexy35gWUlzNPjg942eahH33Bcb2TbQ2sDHM_45JQRlJW_45YgMeta } from "/app/pages/programs/missions/[id]/index.vue?macro=true";
import { default as index3qrTVnO1G4cQ_45CKtCCPoDmNu3Ut0_45Pqpj3ZgPA1rkJ8Meta } from "/app/pages/communication/diffusion/index.vue?macro=true";
import { default as index3XHX9vMU_9_Ng1a6TjoW4aGcStSrziO37OSKjQBw37UMeta } from "/app/pages/parameters/integrations/index.vue?macro=true";
import { default as indexpUSKN38jh3x4dB2o0vZTPekBKyvJ5IKsRguXQ_9np_wMeta } from "/app/pages/seeding/[id]/statistics/index.vue?macro=true";
import { default as index0dHmDikvrielD0n9Zj2gj9Qxf1Q3Or0_F1SjMMu_mO0Meta } from "/app/pages/branding/referrals/modal/index.vue?macro=true";
import { default as _91type_93YZcx23Lt5YCGYeBtHWmB55kWCeqo_Fe9YaaHWXfH_KgMeta } from "/app/pages/parameters/integrations/[type].vue?macro=true";
import { default as gifting_45parametersCRjQ259pquUdAckccB0wbE_45_esRo6suoOSCPNJXgw3cMeta } from "/app/pages/seeding/[id]/gifting-parameters.vue?macro=true";
import { default as index51rOUCq5GXb0Exh8Xpo6B0JWgtk9nS4IqvdWWywVAC0Meta } from "/app/pages/branding/referrals/section/index.vue?macro=true";
import { default as indexXsoED_0kUOxrWBucln7Vuna9BG9O6SNdDdxUmkcJSigMeta } from "/app/pages/programs/missions/template/index.vue?macro=true";
import { default as indexhAT_kYcWbk2K9gwWCgdjT8f0YodeGNvCYRlEjCcKAroMeta } from "/app/pages/vip-tiers/level/[id]/rewards/index.vue?macro=true";
import { default as indexuqnvkxKbWq9n9zWRLntnEqhwmHzrwQARDVSDV5_45LpBUMeta } from "/app/pages/branding/accounts/account-nav/index.vue?macro=true";
import { default as indexH_45gBCSdWWpKS_C2VcFvosMas_45PV8alMUX3ld_ua3QxEMeta } from "/app/pages/branding/accounts/account-loyalty/index.vue?macro=true";
import { default as indexmFMeBpWv2YR1ufiAJ0yO_45_45GtXFbXBOmiWn9ICJL83YAMeta } from "/app/pages/branding/accounts/account-rewards/index.vue?macro=true";
import { default as indexkzYcyw6oOTzJTVu8D8CQO1Tgz47oGh1HUCMp1eUmGdYMeta } from "/app/pages/programs/missions/[id]/statistics/index.vue?macro=true";
import { default as indexVAUFFk6IqrmKCsGS9NcxrkpV_45vvVbehssY0lNsskiZsMeta } from "/app/pages/branding/accounts/account-referral/index.vue?macro=true";
import { default as indextczZIVyByZqbEEQz9C1UX2lZtVPpx4lAT4lCstc_WuAMeta } from "/app/pages/ambassadors/crm/profile/[creator_id]/index.vue?macro=true";
import { default as indexcAje68Qx_Z_xlnDbMJuMQ2erOr6c9dGMP_45dmJ1nUSlQMeta } from "/app/pages/vip-tiers/level/[id]/rewards/[rewardId]/index.vue?macro=true";
import { default as PreviewDetailFormBasetT2IUz2dOCQ90i6GzkBB0tbQAJuNzt_45McspzwiYtwqUMeta } from "/app/pages/seeding/[id]/preview-detail-form/PreviewDetailFormBase.vue?macro=true";
import { default as PreviewDetailFormButtonFV2x1WDUFy6QnndYgt5k0IdSzwSW_459CzOM7MYDTs_fAMeta } from "/app/pages/seeding/[id]/preview-detail-form/PreviewDetailFormButton.vue?macro=true";
import { default as PreviewDetailFormSelectI0Of7xuag6Tt1b6WS1IgOUSzR4Bag2CtRDybaeU9oToMeta } from "/app/pages/seeding/[id]/preview-detail-form/PreviewDetailFormSelect.vue?macro=true";
import { default as PreviewDetailFormTextareatSlaCIX95F4R_xoNgmF_lLh7_45_h_45Gh70hrW0u1X1QSMMeta } from "/app/pages/seeding/[id]/preview-detail-form/PreviewDetailFormTextarea.vue?macro=true";
import { default as PreviewDetailFormInputDate4hlplAUBeaMa3b_6Lv9_YsUJTbJwbv0X21wVPbb_etoMeta } from "/app/pages/seeding/[id]/preview-detail-form/PreviewDetailFormInputDate.vue?macro=true";
import { default as PreviewDetailFormInputTextVqDMS_XMoSgPazPgbZjh0yYYakG1vM8kG5wWsB11WbgMeta } from "/app/pages/seeding/[id]/preview-detail-form/PreviewDetailFormInputText.vue?macro=true";
import { default as PreviewDetailFormBaseChoice_t1G87GBWtNOGN_45LLX_9kPhDQ0ixAP_45i_g5jOeNaD4EMeta } from "/app/pages/seeding/[id]/preview-detail-form/PreviewDetailFormBaseChoice.vue?macro=true";
import { default as PreviewDetailFormInputPhonerVMNHJO3QgN0h6MCy8X2ToYy9PZJ1kmPRsxoQZd9QYcMeta } from "/app/pages/seeding/[id]/preview-detail-form/PreviewDetailFormInputPhone.vue?macro=true";
import { default as PreviewDetailFormRadioGroup66Xh__YI5QUJJCHUXu9OJki8ea9Ex7tvVhAfCt4w0kIMeta } from "/app/pages/seeding/[id]/preview-detail-form/PreviewDetailFormRadioGroup.vue?macro=true";
import { default as PreviewDetailFormCheckboxGroupqbOwwKlnuqMwfwsJ6g0qgQe2zH4n062Ys892XBsbNWAMeta } from "/app/pages/seeding/[id]/preview-detail-form/PreviewDetailFormCheckboxGroup.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "home",
    path: "/home",
    meta: indexQ_45p_R8nWqy4cZICdOG47zZGdB894pqt8jkBF_45IT0qhIMeta || {},
    component: () => import("/app/pages/home/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: index06RuUPKkpIkYJ1u5ZQ6kHhkE76Z6rwcTsSwg0fLJR9IMeta || {},
    component: () => import("/app/pages/login/index.vue")
  },
  {
    name: "rewards-new",
    path: "/rewards/new",
    meta: newWc_F9IF7ScYj8JRK2BJERfFQIISxrzktOXmpI0DlbpAMeta || {},
    component: () => import("/app/pages/rewards/new.vue")
  },
  {
    name: "seeding-send",
    path: "/seeding/send",
    meta: send_k0b_45AjsM0cTyp5mMJ_BbKW1LQAyZj2XdxI_Ge9H9rEMeta || {},
    component: () => import("/app/pages/seeding/send.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexcpQviwpni6wMDdVA_BzQ_45kBCtc89Z5fb_458HFdQRVAm8Meta || {},
    component: () => import("/app/pages/sign-up/index.vue")
  },
  {
    name: "branding",
    path: "/branding",
    meta: index_co3iOp8B9M5qx3rHu_45X0i7TlvmPQyobRFNEElS73OcMeta || {},
    component: () => import("/app/pages/branding/index.vue")
  },
  {
    name: "referral",
    path: "/referral",
    meta: indexfodtTBtuLo_45yQsALKT8_4522bgRi9W4SQ_MW16Qo5TXckMeta || {},
    component: () => import("/app/pages/referral/index.vue")
  },
  {
    name: "seeding-product",
    path: "/seeding/product",
    meta: productYY3eUPbIONly1KIDLSQT6eKmXC6hZo_INFaqh9EyxWkMeta || {},
    component: () => import("/app/pages/seeding/product.vue")
  },
  {
    name: "seeding-upgrade",
    path: "/seeding/upgrade",
    meta: upgrademh_45hnbAfnM60_45jiiE8As5CYTVN6e79WI1syU_45XCTGVkMeta || {},
    component: () => import("/app/pages/seeding/upgrade.vue")
  },
  {
    name: "shopify-install",
    path: "/shopify/install",
    component: () => import("/app/pages/shopify/install.vue")
  },
  {
    name: "vip-tiers",
    path: "/vip-tiers",
    meta: indexdrrcxBLgKkbQGcJP_0EWHslYcJSUtUUVRdOVJw3L7_wMeta || {},
    component: () => import("/app/pages/vip-tiers/index.vue")
  },
  {
    name: "referral-upgrade",
    path: "/referral/upgrade",
    meta: upgrade9GvkqavSyByM6RRWq3u7G6L6WLHHCmm_wAu6wTyKdgsMeta || {},
    component: () => import("/app/pages/referral/upgrade.vue")
  },
  {
    name: "rewards-template",
    path: "/rewards/template",
    meta: templateD5OeSL_45sKCLAVW5Tf2fzCllhWbfnK_b8jwl4_45ShRzhgMeta || {},
    component: () => import("/app/pages/rewards/template.vue")
  },
  {
    name: "seeding-campaigns",
    path: "/seeding/campaigns",
    meta: campaignstCfNk2hnXxDI3b0K8EeWtNPuGYV71sTAPjM_45z8dH1uwMeta || {},
    component: () => import("/app/pages/seeding/campaigns.vue")
  },
  {
    name: "vip-tiers-upgrade",
    path: "/vip-tiers/upgrade",
    meta: upgradeD9xwZ_45RJA85GHaIVdvArdfhnVInFIHeJEwyLRMgyoT8Meta || {},
    component: () => import("/app/pages/vip-tiers/upgrade.vue")
  },
  {
    name: "prestashop-install",
    path: "/prestashop/install",
    component: () => import("/app/pages/prestashop/install.vue")
  },
  {
    name: "rewards-id",
    path: "/rewards/:id()",
    meta: indexJpATDRW0GsZkb3b3Ur2EexyX9qTGUX42SA5_45XZts1AMMeta || {},
    component: () => import("/app/pages/rewards/[id]/index.vue")
  },
  {
    name: "rewards-list",
    path: "/rewards/list",
    meta: indexpxwYt6birg4MZhQQf3tPpVYjL5QJcHRqlOuNkRwi84EMeta || {},
    component: () => import("/app/pages/rewards/list/index.vue")
  },
  {
    name: "rewards-send",
    path: "/rewards/send",
    meta: indexAVrTFjKauXzLEpvLVNhz_1DXD7rtw1qF1kXzyK2WrocMeta || {},
    component: () => import("/app/pages/rewards/send/index.vue")
  },
  {
    name: "seeding-id",
    path: "/seeding/:id()",
    meta: index6vWdshgMcWZlynt0_NWkkRc0tazoZU3VawCbwuBoyqQMeta || {},
    component: () => import("/app/pages/seeding/[id]/index.vue")
  },
  {
    name: "branding-page",
    path: "/branding/page",
    meta: index3QEx2FupW0AHCWvpxVVvjKuXWAsm6QUihF_Yjwl3UbYMeta || {},
    component: () => import("/app/pages/branding/page/index.vue")
  },
  {
    name: "branding-steps",
    path: "/branding/steps",
    meta: indexVQ_453amrRfo5jb_45mTQD0BgssIFcK7COyh7oObMvIkiqEMeta || {},
    component: () => import("/app/pages/branding/steps/index.vue")
  },
  {
    name: "company-create",
    path: "/company/create",
    meta: indexCgWkt59pzwVVHr4q1qrrnsVjZHSE2M81ROGrLb_bVaMMeta || {},
    component: () => import("/app/pages/company/create/index.vue")
  },
  {
    name: "login-password-reset",
    path: "/login/password-reset",
    component: () => import("/app/pages/login/password-reset.vue")
  },
  {
    name: "seeding-id-preview",
    path: "/seeding/:id()/preview",
    component: () => import("/app/pages/seeding/[id]/preview.vue")
  },
  {
    name: "seeding-applications",
    path: "/seeding/applications",
    meta: applicationsweQ7d27k_45HFZhJ0AFh2nF2M1FJPLtENqBhMzZJc782IMeta || {},
    component: () => import("/app/pages/seeding/applications.vue")
  },
  {
    name: "ambassadors-crm",
    path: "/ambassadors/crm",
    meta: indexd44eJ6_45Q9BmvwX13caOoD9UpSnP_45vTDTmw_45pEnO95XcMeta || {},
    component: () => import("/app/pages/ambassadors/crm/index.vue")
  },
  {
    name: "branding-banner",
    path: "/branding/banner",
    meta: indexXcEmH4PZTQXHDHYmFIRejk3ZpAXG7gc2P_WYRRhb1EYMeta || {},
    component: () => import("/app/pages/branding/banner/index.vue")
  },
  {
    name: "branding-profil",
    path: "/branding/profil",
    meta: indexqLOBV5QtUP7Hl9rrDFTCxOk3gWHvpMSVh20elGW1FJcMeta || {},
    component: () => import("/app/pages/branding/profil/index.vue")
  },
  {
    name: "login-password-forgot",
    path: "/login/password-forgot",
    meta: password_45forgottjU1zsFG8aQAD5hVUXj2STSakaR_1E_45rLLhLCg8Hx_oMeta || {},
    component: () => import("/app/pages/login/password-forgot.vue")
  },
  {
    name: "referral-rewards-id",
    path: "/referral/rewards/:id()",
    meta: _91id_93wMll62X3EKy057yKLFg8baHeGD4XTERBgygVzD9nRLwMeta || {},
    component: () => import("/app/pages/referral/rewards/[id].vue")
  },
  {
    name: "seeding-id-missions",
    path: "/seeding/:id()/missions",
    meta: missionsBRvANH11AHBu09Uza9dyMWysP6LX4C0U3jGLwR1QRREMeta || {},
    component: () => import("/app/pages/seeding/[id]/missions.vue")
  },
  {
    name: "vip-tiers-level",
    path: "/vip-tiers/level",
    meta: indexzzRbHYobRshklfqqQS_RCUtH0rmjXVYZg_45OrBqf1ZP8Meta || {},
    component: () => import("/app/pages/vip-tiers/level/index.vue")
  },
  {
    name: "branding-general",
    path: "/branding/general",
    meta: index_TkLrTl21T2Zb_QJVHqRcaoz53K738TcP7BoYGbWavMMeta || {},
    component: () => import("/app/pages/branding/general/index.vue")
  },
  {
    name: "branding-gifting",
    path: "/branding/gifting",
    meta: indexj_45ai1gcaBu1ZBexpRsg3yKoYyEqSWVeh_45JNd1AzseaIMeta || {},
    component: () => import("/app/pages/branding/gifting/index.vue")
  },
  {
    name: "branding-modules",
    path: "/branding/modules",
    meta: indexFM_45ysw42yV_gGaU3ILcxbJWTiXczLmR1hClGm6En_45BMMeta || {},
    component: () => import("/app/pages/branding/modules/index.vue")
  },
  {
    name: "branding-rewards",
    path: "/branding/rewards",
    meta: indexxlXOOnSLmm4ueaZS7B7uChuuFHdqh061VFSojCZrWHYMeta || {},
    component: () => import("/app/pages/branding/rewards/index.vue")
  },
  {
    name: "contents-library",
    path: "/contents/library",
    meta: indexAYnxRMyB2ewWYgYebdXQiscZ8R26_45Z4yV1Igvyqmx6gMeta || {},
    component: () => import("/app/pages/contents/library/index.vue")
  },
  {
    name: "branding-accounts",
    path: "/branding/accounts",
    meta: indexRHkQiexfp09NoNWXqDpKF5eGhQ4t423gwEJZYP_45wgHUMeta || {},
    component: () => import("/app/pages/branding/accounts/index.vue")
  },
  {
    name: "branding-missions",
    path: "/branding/missions",
    meta: indexezAfeBhJejKG7qs6kOp1uioJ8UI6RW_45bWtMDKxb_45DR8Meta || {},
    component: () => import("/app/pages/branding/missions/index.vue")
  },
  {
    name: "dashboard-loyalty",
    path: "/dashboard/loyalty",
    meta: index09IMUKHyrMNXzpS0Jkjze1JDCisDV378pPO8KyC5AokMeta || {},
    component: () => import("/app/pages/dashboard/loyalty/index.vue")
  },
  {
    name: "parameters-profil",
    path: "/parameters/profil",
    meta: indexvKH6g5D4HP5NfyQE2T7jmjRH7TXFg8GLaVHG4Skk1bYMeta || {},
    component: () => import("/app/pages/parameters/profil/index.vue")
  },
  {
    name: "programs-missions",
    path: "/programs/missions",
    meta: indexGmj_45eQHV1uYCaO3RXkFV032UWLjcSMGR4ltY0K90GZcMeta || {},
    component: () => import("/app/pages/programs/missions/index.vue")
  },
  {
    name: "seeding-id-targetings",
    path: "/seeding/:id()/targetings",
    meta: targetingsUo_1dbd2Xb2TPN5POfrEHZuHUmbng0ZgGaaZTkL9zZkMeta || {},
    component: () => import("/app/pages/seeding/[id]/targetings.vue")
  },
  {
    name: "branding-referrals",
    path: "/branding/referrals",
    meta: indexAKnUA00ieDO_45tTF7Hav3gxTsKmZviHXn69HINw1J3W0Meta || {},
    component: () => import("/app/pages/branding/referrals/index.vue")
  },
  {
    name: "branding-vip-tiers",
    path: "/branding/vip-tiers",
    meta: indexqsrcqPoS1N9JP7emjfuCw0DpjBiDYOlcCjoA8XWyHtsMeta || {},
    component: () => import("/app/pages/branding/vip-tiers/index.vue")
  },
  {
    name: "dashboard-missions",
    path: "/dashboard/missions",
    meta: indexLI00dfQCYGtD3TmC_v6mVAGaa5a_45XM7EN1d72R9InNcMeta || {},
    component: () => import("/app/pages/dashboard/missions/index.vue")
  },
  {
    name: "dashboard-referral",
    path: "/dashboard/referral",
    meta: indexJJ3aondRJkCU9OCuWWprulOVOiGs0DZOCSH41iXc_CgMeta || {},
    component: () => import("/app/pages/dashboard/referral/index.vue")
  },
  {
    name: "parameters-billing",
    path: "/parameters/billing",
    meta: indexkdzcV0fY2swAtoWQ3N9D01QbSqAJp_45NtBfvul32pUTQMeta || {},
    component: () => import("/app/pages/parameters/billing/index.vue")
  },
  {
    name: "seeding-id-recruitment",
    path: "/seeding/:id()/recruitment",
    meta: recruitmentZqyGoXRtTmx_45wl_HQdGn65Te9RiAo_45Sxy69IkwWdh1MMeta || {},
    component: () => import("/app/pages/seeding/[id]/recruitment.vue")
  },
  {
    name: "sign-up-onboarding-final",
    path: "/sign-up/onboarding/final",
    meta: finalYDbQoKbwvYnj_45rsvTdMIeRm89lBl2vrH1AODuO9riDwMeta || {},
    component: () => import("/app/pages/sign-up/onboarding/final.vue")
  },
  {
    name: "sign-up-onboarding-goals",
    path: "/sign-up/onboarding/goals",
    meta: goalsLfYOWh_45PfsCh3kjd5hs29VSnc7QeRkqB3n76FIOTdrQMeta || {},
    component: () => import("/app/pages/sign-up/onboarding/goals.vue")
  },
  {
    name: "contents-moderation",
    path: "/contents/moderation",
    meta: indexkh9esqB_D6soSPABtVKCrL9xpGox_45u93Jf5v0WJ8mcUMeta || {},
    component: () => import("/app/pages/contents/moderation/index.vue")
  },
  {
    name: "dashboard-retention",
    path: "/dashboard/retention",
    meta: indexwqZuM0lGVSQgPHXKG_453MR876e_458fcV2o1Vd6SrP6O2IMeta || {},
    component: () => import("/app/pages/dashboard/retention/index.vue")
  },
  {
    name: "parameters-billing-failed",
    path: "/parameters/billing/failed",
    meta: failedw3Ld7jVfJlz5IBuqqwXetbCVMJ0SvJz_GOKyBBqXn6oMeta || {},
    component: () => import("/app/pages/parameters/billing/failed.vue")
  },
  {
    name: "communication-emails",
    path: "/communication/emails",
    meta: indexRXRgniVlyyTE3rpjgyqg5_45nBggTxugSd9GhS4iO_0v0Meta || {},
    component: () => import("/app/pages/communication/emails/index.vue")
  },
  {
    name: "parameters-billing-success",
    path: "/parameters/billing/success",
    meta: successx_45jCFuMgmaQM7LiK9wAJXuNnBlRpu84eKAywJ_45YmhJUMeta || {},
    component: () => import("/app/pages/parameters/billing/success.vue")
  },
  {
    name: "sign-up-onboarding-loyalty",
    path: "/sign-up/onboarding/loyalty",
    meta: loyalty9YM89LydJVZ2xrWss35QF2yR5k9VKdEYL_xExsKcb2AMeta || {},
    component: () => import("/app/pages/sign-up/onboarding/loyalty.vue")
  },
  {
    name: "sign-up-onboarding-rewards",
    path: "/sign-up/onboarding/rewards",
    meta: rewardsSZlxJyqgDsLKSLL4natqHiLfzsUY3BaTbIsx5cLOoa8Meta || {},
    component: () => import("/app/pages/sign-up/onboarding/rewards.vue")
  },
  {
    name: "sign-up-onboarding-socials",
    path: "/sign-up/onboarding/socials",
    meta: socialsFrzvCG2LYwxGfM_45oVwYn_45cpOT1TlKSgTOmas4xyArW0Meta || {},
    component: () => import("/app/pages/sign-up/onboarding/socials.vue")
  },
  {
    name: "sign-up-onboarding-website",
    path: "/sign-up/onboarding/website",
    meta: websiteffZUSmSGrtxCaU3uXInQUtb0eUVfaBUNcSn2OkQWWq0Meta || {},
    component: () => import("/app/pages/sign-up/onboarding/website.vue")
  },
  {
    name: "vip-tiers-level-id",
    path: "/vip-tiers/level/:id()",
    meta: indexR9262P9JWb1gD9sUEg__fUPQHi2I_45D8ZsMk6lrGEvCEMeta || {},
    component: () => import("/app/pages/vip-tiers/level/[id]/index.vue")
  },
  {
    name: "branding-translations",
    path: "/branding/translations",
    meta: indexAT2AySntsIhLqPHRxNgLUwp0pB6n10uthD2Hdc7y1gYMeta || {},
    component: () => import("/app/pages/branding/translations/index.vue")
  },
  {
    name: "programs-loyalty-id",
    path: "/programs/loyalty/:id()",
    meta: index83wnLSxCrRwICzfXySQWOb7qiMFsj1YB6HhpSeePFioMeta || {},
    component: () => import("/app/pages/programs/loyalty/[id]/index.vue")
  },
  {
    name: "programs-missions-new",
    path: "/programs/missions/new",
    meta: indexIYWy1APJ8ADhiMc0cHWm__45PPjjDpa3q8WgOM4TVrcVcMeta || {},
    component: () => import("/app/pages/programs/missions/new/index.vue")
  },
  {
    name: "seeding-id-preview-detail",
    path: "/seeding/:id()/preview-detail",
    component: () => import("/app/pages/seeding/[id]/preview-detail.vue")
  },
  {
    name: "sign-up-onboarding-branding",
    path: "/sign-up/onboarding/branding",
    meta: brandingncKeAgicFLO4kXtGIW0M1LbtW8MRRVnWtdPnQgb1T5MMeta || {},
    component: () => import("/app/pages/sign-up/onboarding/branding.vue")
  },
  {
    name: "sign-up-onboarding-referral",
    path: "/sign-up/onboarding/referral",
    meta: referral6dEsTv6a0bnr7_45jky5LkmZjJBK3uNucd2xRLHieXQj8Meta || {},
    component: () => import("/app/pages/sign-up/onboarding/referral.vue")
  },
  {
    name: "programs-missions-id",
    path: "/programs/missions/:id()",
    meta: indexy35gWUlzNPjg942eahH33Bcb2TbQ2sDHM_45JQRlJW_45YgMeta || {},
    component: () => import("/app/pages/programs/missions/[id]/index.vue")
  },
  {
    name: "communication-diffusion",
    path: "/communication/diffusion",
    meta: index3qrTVnO1G4cQ_45CKtCCPoDmNu3Ut0_45Pqpj3ZgPA1rkJ8Meta || {},
    component: () => import("/app/pages/communication/diffusion/index.vue")
  },
  {
    name: "parameters-integrations",
    path: "/parameters/integrations",
    meta: index3XHX9vMU_9_Ng1a6TjoW4aGcStSrziO37OSKjQBw37UMeta || {},
    component: () => import("/app/pages/parameters/integrations/index.vue")
  },
  {
    name: "seeding-id-statistics",
    path: "/seeding/:id()/statistics",
    meta: indexpUSKN38jh3x4dB2o0vZTPekBKyvJ5IKsRguXQ_9np_wMeta || {},
    component: () => import("/app/pages/seeding/[id]/statistics/index.vue")
  },
  {
    name: "branding-referrals-modal",
    path: "/branding/referrals/modal",
    meta: index0dHmDikvrielD0n9Zj2gj9Qxf1Q3Or0_F1SjMMu_mO0Meta || {},
    component: () => import("/app/pages/branding/referrals/modal/index.vue")
  },
  {
    name: "parameters-integrations-type",
    path: "/parameters/integrations/:type()",
    meta: _91type_93YZcx23Lt5YCGYeBtHWmB55kWCeqo_Fe9YaaHWXfH_KgMeta || {},
    component: () => import("/app/pages/parameters/integrations/[type].vue")
  },
  {
    name: "seeding-id-gifting-parameters",
    path: "/seeding/:id()/gifting-parameters",
    meta: gifting_45parametersCRjQ259pquUdAckccB0wbE_45_esRo6suoOSCPNJXgw3cMeta || {},
    component: () => import("/app/pages/seeding/[id]/gifting-parameters.vue")
  },
  {
    name: "branding-referrals-section",
    path: "/branding/referrals/section",
    meta: index51rOUCq5GXb0Exh8Xpo6B0JWgtk9nS4IqvdWWywVAC0Meta || {},
    component: () => import("/app/pages/branding/referrals/section/index.vue")
  },
  {
    name: "programs-missions-template",
    path: "/programs/missions/template",
    meta: indexXsoED_0kUOxrWBucln7Vuna9BG9O6SNdDdxUmkcJSigMeta || {},
    component: () => import("/app/pages/programs/missions/template/index.vue")
  },
  {
    name: "vip-tiers-level-id-rewards",
    path: "/vip-tiers/level/:id()/rewards",
    meta: indexhAT_kYcWbk2K9gwWCgdjT8f0YodeGNvCYRlEjCcKAroMeta || {},
    component: () => import("/app/pages/vip-tiers/level/[id]/rewards/index.vue")
  },
  {
    name: "branding-accounts-account-nav",
    path: "/branding/accounts/account-nav",
    meta: indexuqnvkxKbWq9n9zWRLntnEqhwmHzrwQARDVSDV5_45LpBUMeta || {},
    component: () => import("/app/pages/branding/accounts/account-nav/index.vue")
  },
  {
    name: "branding-accounts-account-loyalty",
    path: "/branding/accounts/account-loyalty",
    meta: indexH_45gBCSdWWpKS_C2VcFvosMas_45PV8alMUX3ld_ua3QxEMeta || {},
    component: () => import("/app/pages/branding/accounts/account-loyalty/index.vue")
  },
  {
    name: "branding-accounts-account-rewards",
    path: "/branding/accounts/account-rewards",
    meta: indexmFMeBpWv2YR1ufiAJ0yO_45_45GtXFbXBOmiWn9ICJL83YAMeta || {},
    component: () => import("/app/pages/branding/accounts/account-rewards/index.vue")
  },
  {
    name: "programs-missions-id-statistics",
    path: "/programs/missions/:id()/statistics",
    meta: indexkzYcyw6oOTzJTVu8D8CQO1Tgz47oGh1HUCMp1eUmGdYMeta || {},
    component: () => import("/app/pages/programs/missions/[id]/statistics/index.vue")
  },
  {
    name: "branding-accounts-account-referral",
    path: "/branding/accounts/account-referral",
    meta: indexVAUFFk6IqrmKCsGS9NcxrkpV_45vvVbehssY0lNsskiZsMeta || {},
    component: () => import("/app/pages/branding/accounts/account-referral/index.vue")
  },
  {
    name: "ambassadors-crm-profile-creator_id",
    path: "/ambassadors/crm/profile/:creator_id()",
    meta: indextczZIVyByZqbEEQz9C1UX2lZtVPpx4lAT4lCstc_WuAMeta || {},
    component: () => import("/app/pages/ambassadors/crm/profile/[creator_id]/index.vue")
  },
  {
    name: "vip-tiers-level-id-rewards-rewardId",
    path: "/vip-tiers/level/:id()/rewards/:rewardId()",
    meta: indexcAje68Qx_Z_xlnDbMJuMQ2erOr6c9dGMP_45dmJ1nUSlQMeta || {},
    component: () => import("/app/pages/vip-tiers/level/[id]/rewards/[rewardId]/index.vue")
  },
  {
    name: "seeding-id-preview-detail-form-PreviewDetailFormBase",
    path: "/seeding/:id()/preview-detail-form/PreviewDetailFormBase",
    component: () => import("/app/pages/seeding/[id]/preview-detail-form/PreviewDetailFormBase.vue")
  },
  {
    name: "seeding-id-preview-detail-form-PreviewDetailFormButton",
    path: "/seeding/:id()/preview-detail-form/PreviewDetailFormButton",
    component: () => import("/app/pages/seeding/[id]/preview-detail-form/PreviewDetailFormButton.vue")
  },
  {
    name: "seeding-id-preview-detail-form-PreviewDetailFormSelect",
    path: "/seeding/:id()/preview-detail-form/PreviewDetailFormSelect",
    component: () => import("/app/pages/seeding/[id]/preview-detail-form/PreviewDetailFormSelect.vue")
  },
  {
    name: "seeding-id-preview-detail-form-PreviewDetailFormTextarea",
    path: "/seeding/:id()/preview-detail-form/PreviewDetailFormTextarea",
    component: () => import("/app/pages/seeding/[id]/preview-detail-form/PreviewDetailFormTextarea.vue")
  },
  {
    name: "seeding-id-preview-detail-form-PreviewDetailFormInputDate",
    path: "/seeding/:id()/preview-detail-form/PreviewDetailFormInputDate",
    component: () => import("/app/pages/seeding/[id]/preview-detail-form/PreviewDetailFormInputDate.vue")
  },
  {
    name: "seeding-id-preview-detail-form-PreviewDetailFormInputText",
    path: "/seeding/:id()/preview-detail-form/PreviewDetailFormInputText",
    component: () => import("/app/pages/seeding/[id]/preview-detail-form/PreviewDetailFormInputText.vue")
  },
  {
    name: "seeding-id-preview-detail-form-PreviewDetailFormBaseChoice",
    path: "/seeding/:id()/preview-detail-form/PreviewDetailFormBaseChoice",
    component: () => import("/app/pages/seeding/[id]/preview-detail-form/PreviewDetailFormBaseChoice.vue")
  },
  {
    name: "seeding-id-preview-detail-form-PreviewDetailFormInputPhone",
    path: "/seeding/:id()/preview-detail-form/PreviewDetailFormInputPhone",
    component: () => import("/app/pages/seeding/[id]/preview-detail-form/PreviewDetailFormInputPhone.vue")
  },
  {
    name: "seeding-id-preview-detail-form-PreviewDetailFormRadioGroup",
    path: "/seeding/:id()/preview-detail-form/PreviewDetailFormRadioGroup",
    component: () => import("/app/pages/seeding/[id]/preview-detail-form/PreviewDetailFormRadioGroup.vue")
  },
  {
    name: "seeding-id-preview-detail-form-PreviewDetailFormCheckboxGroup",
    path: "/seeding/:id()/preview-detail-form/PreviewDetailFormCheckboxGroup",
    component: () => import("/app/pages/seeding/[id]/preview-detail-form/PreviewDetailFormCheckboxGroup.vue")
  }
]